<template>
  <div class="actions-row">
    <v-tooltip top v-if="permissions.financial[subpage].actions.edit">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="$emit('edit', value)"
        >
          <v-icon>mdi-playlist-edit</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.periodicals.actions.edit }}</span>
    </v-tooltip>
    <v-tooltip top v-if="permissions.financial[subpage].actions.delete">
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          small
          class="mr-2"
          @click.stop="delete_(value)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.financial.periodicals.actions.delete }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import periodicals from '../mixins/index'

export default {
  mixins: [ appdata, periodicals ],
  props: {
    value: {
      type: Object,
      required: true
    },
    subpage: {
      type: String,
      required: true
    }
  }
}
</script>

<style>
#app .actions-row {
  width: 109px;
}
</style>
